import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

import EditRentalAgreementHistoryForm from './Form'

export default function EditRentalAgreementHistoryModal({
  close,
  isOpen,
  onSuccess,
  rentalAgreementHistory
}: {
  close: () => void
  isOpen: boolean
  onSuccess?: () => void
  rentalAgreementHistory: any
}) {
  return (
    <>
      <Modal toggle={close} isOpen={isOpen}>
        <ModalHeader toggle={close}>Edit Rental Agreement History</ModalHeader>
        <ModalBody>
          <EditRentalAgreementHistoryForm
            onSubmit={close}
            onSuccess={onSuccess}
            rentalAgreementHistory={rentalAgreementHistory}
          />
        </ModalBody>
      </Modal>
    </>
  )
}
